import React, { useState, useEffect } from 'react'
import { getDetailTemplateMember } from '../../../../services/template'
import { Box, Text, Flex, Button, Paper, Image, Title } from '@mantine/core'
import LoadingDataModal from '../../../ui/LoadingDataModal'
import { getImageFile } from '../../../../services/fileImage'
import NoImage from '../../../../assets/img/no-image.png'
import { useViewportSize } from '@mantine/hooks'
import classes from '../../../../pages/Member/MemberPage.module.css'
import { IconDownload } from '@tabler/icons-react'

const DetailTemplate = ({ idTemplate, onCloseModal }) => {
  const { width } = useViewportSize()
  const [loading, setLoading] = useState(true)
  const [templateDetail, setTemplateDetail] = useState(null)

  const handleGetDetailTemplate = async (templateId) => {
    setLoading(true)
    try {
      const response = await getDetailTemplateMember(templateId)
      setTemplateDetail(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (idTemplate !== null) {
      handleGetDetailTemplate(idTemplate)
    }
  }, [idTemplate])

  const loadDataTemplate = (data) => {

    const handleOpenLinkTemplate = (link) => {
      let url = ''
      const checkUrl = !/^https?:\/\//.test(link)
      if (checkUrl) {
        url = `https://` + link
      } else {
        url = link
      }
      // eslint-disable-next-line
      window.open(`${url}`, '_blank')
    }

    if (data !== null) {
      const innerHtml = { __html: data.eventSchedule.event.longDescription }
      return (
        <Box>
          <Paper shadow='xs' radius='md' withBorder>
            <Box ta='center'>
              <Image
                radius="md"
                h={width > 768 ? 340 : 220}
                fit="cover"
                src={data.eventSchedule.event.eventImages.length > 0 ? getImageFile(data.eventSchedule.event.eventImages[0].filepath) : NoImage} 
              />
            </Box>
          </Paper>
          <Box mt={15}>
            <Title className={classes.titleHeader}>{data.eventSchedule.event.name}</Title>
            <Box my={10}>
              <Text className={classes.titleSection} fw="bold">Tentang</Text>
              <Text fz="xs">{data.eventSchedule.event.longDescription ? (<Box dangerouslySetInnerHTML={innerHtml}/>) : '-'}</Text>
            </Box>
            <Flex justify='start' mb={16}>
              <Button size="xs" leftSection={<IconDownload size="1rem" />} color='red' onClick={() => handleOpenLinkTemplate(data.eventSchedule.onlineLink)}>Download Template</Button>
            </Flex>
          </Box>
        </Box>
      )
    }
  }


  return (
    <Box>
      {loading ? <LoadingDataModal/> : loadDataTemplate(templateDetail)}
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Button variant="outline" color='indigo.9' onClick={onCloseModal}>Tutup</Button>
        </Flex>
      </Box>
    </Box>
  )
}

export default DetailTemplate